import { render, staticRenderFns } from "./ContentButton.vue?vue&type=template&id=ef843b1c&"
import script from "./ContentButton.vue?vue&type=script&lang=ts&"
export * from "./ContentButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports